module.exports = __webpack_public_path__ + "dd802e14a.png";